import {AgencySettings} from './clients.types';

const SUSPEND_DAYS_MIN = 30;
const SUSPEND_DAYS_MAX = 180;
const SUSPEND_DAYS_DEFAULT = 90;

const defaultServiceSettings = {
  isIp2LocationEnabled: false,
  isWeatherTargetingEnabled: false,
  isSportServicesEnabled: false,
  isMediaCostEnabled: false,
  isConversionAttributionUsingClinchClickIdEnabled: false,
  isBackgroundRemovalInFeedsEnabled: false,
  isOutputDataFeedsStandardLogsEnabled: false,
  isOutputDataFeedsConnectedLogsEnabled: false,
  isOutputDataFeedsCVREnabled: false,
};

const defaultAgencySettings: AgencySettings = {
  clientId: 0,
  isOutputDataFeedsStandardLogsEnabled: false,
  isOutputDataFeedsConnectedLogsEnabled: false,
  isOutputDataFeedsCVREnabled: false,
  defaultDatetimeFormat: '',
  isMultiFactorEnabled: false,
};

const defaultAnalyticsSettings = {
  isVtcInTotalSalesEnabled: false,
  isSpentInAnalyticsPageEnabled: false,
  isTotalSalesInAnalyticsPageEnabled: false,
};

export {
  SUSPEND_DAYS_MIN,
  SUSPEND_DAYS_MAX,
  SUSPEND_DAYS_DEFAULT,
  defaultServiceSettings,
  defaultAnalyticsSettings,
  defaultAgencySettings,
};
